import { render, staticRenderFns } from "./FormBomb.vue?vue&type=template&id=9ff706b2&scoped=true&"
import script from "./FormBomb.vue?vue&type=script&lang=js&"
export * from "./FormBomb.vue?vue&type=script&lang=js&"
import style0 from "./FormBomb.vue?vue&type=style&index=0&id=9ff706b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff706b2",
  null
  
)

export default component.exports